import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import moment from "moment";
// Antd
import { Typography, Row, Col, Icon, Collapse, Tabs } from "antd";

// Formik
import { FastField, Formik } from "formik";

// Yup
import * as Yup from "yup";

// Component
import Button from "../../../../components/Buttons";
import Input from "../../../../components/Common/Input";
import typo, { MESSAGE } from "../../../../constants/dictionaries";
import Select from "../../../../components/Common/Select";
import message from "../../../../components/Messages";
import DateField from "../../../../components/Common/DateField"
import ValidatedText from "../../../../components/Common/ValidatedText";
import DonViXCPGroup from "../../../../components/License/DonViDCPGroup";
import TextArea from "../../../../components/Common/TextArea";
import FileDinhKemPlus from "../../../../components/ThongTinTNN/FileDinhKem/TablePlus"
import ChatLuongNuocThai from "../../../../components/BaoCaoDinhKy/ChatLuongXaThai/Table"
import NumberField from "../../../../components/Common/NumberField";
// Colors
import colors from "../../../../constants/colors";

// Styled components
import styles from "./Modal.module.scss";
import Api_tnn from "../../../../api/api.tnn";
import Helper from "../../../../helper/helper";
import Box from "../../../../components/Box";
import ChatLuongNuocMat from "../../../../components/BaoCaoDinhKy/ChatLuongNuocMat/Table";
import Constant from "../../../../constants/constant";
const { Text } = Typography;
const { TabPane } = Tabs;
const ControllerForm = styled.div`
  // border: 1px solid #c8ced3;
  border-radius: 5px;
  background: ${colors.white};
`;
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;
const ControllerFile = styled.div`
  padding-top: 30px;
`;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
const dateFormat = 'DD/MM/YYYY';
// Validations for add user
const addOrEditSchema = Yup.object().shape({
  idGiayPhep: Yup.string().required(typo.cscore_input_Required),
  namBaoCao: Yup.string().required(typo.cscore_input_Required),
  dotBaoCao: Yup.string().required(typo.cscore_input_Required),
  tenBaoCao: Yup.string().required(typo.cscore_input_Required),
});

class DNBCModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {},
      dataGiayPhep: [],
      loaiGP: undefined,
      idGiayPhep: undefined,
      dataCLXT: undefined,
      dataCLNM: undefined,
      dataCLNDD: undefined,
      danhgia: this.props.selectedRow ? this.props.selectedRow.ketQua_DanhGia ? this.props.selectedRow.ketQua_DanhGia : 2 : 2,
      years: [],
      CLXT: [],
      CLNM: [],
      CLNDD: [],
      fileList: this.props.selectedRow ? this.props.selectedRow.fileDinhKems : undefined,
    };
  }

  componentDidMount() {
    const { isEdit, selectedRow } = this.props
    this.getYears()
    if (isEdit) {
      this.Get_BCDK_CauHinhTS(selectedRow.idGiayPhep)
      this.setState({
        initialValues: {
          ...selectedRow,
          idDonViXinCapPhep: selectedRow.idToChuc_CaNhan,
          tenDonViXCP: selectedRow.tenToChuc_CaNhan,
          diaChiDonViXCP: selectedRow.diaChi,
        },
        CLXT: selectedRow.clnT_KQQT_LIST ? JSON.parse(selectedRow.clnT_KQQT_LIST) : [],
        CLNM: selectedRow.clnM_KQQT_LIST ? JSON.parse(selectedRow.clnM_KQQT_LIST) : [],
        CLNDD: selectedRow.clndD_KQQT_LIST ? JSON.parse(selectedRow.clndD_KQQT_LIST) : [],
        idGiayPhep: selectedRow.idGiayPhep,
        loaiGP: selectedRow.nhomCongTrinh
      })
    }
  }
  getYears = () => {
    var c_year = new Date().getFullYear(); var years = []
    for (var i = c_year + 20; i >= 1975; i--) { years.push({ year: i }) }
    this.setState({ years: years })
  }
  updateFileDinhKems = (items) => {
    this.setState({
      fileList: items
    })
  }

  GetCT_GiayPhep_ByIdDVXCP = (iddvxcp) => {
    const { user } = this.props;
    new Api_tnn().GetCT_GiayPhep_ByIdDVXCP({ token: user.access_token, iddvxcp: iddvxcp })
      .then(res => {
        this.setState({ dataGiayPhep: res })
      })
      .catch((err) => message.error(err.message))
  };

  Get_BCDK_CauHinhTS = (IdGiayPhep) => {
    const { user } = this.props;
    new Api_tnn().Get_BCDK_CauHinhTS({ token: user.access_token, IdGiayPhep: IdGiayPhep })
      .then((res) => {
        if (res.length > 0) {
          this.setState({
            dataCLXT: res[0].clnT_ThongSos,
            dataCLNM: res[0].clnM_ThongSos,
            dataCLNDD: res[0].clndD_ThongSos,
          })
        } else {
          this.setState({
            dataCLXT: "[]",
            dataCLNM: "[]",
            dataCLNDD: "[]",
          })
        }
      })
      .catch((err) => message.error(err.message))
  };
  Post_BCDK_CauHinhTS = (IdGiayPhep, cauhinh) => {
    const { user } = this.props;
    new Api_tnn().Post_BCDK_CauHinhTS({ token: user.access_token, IdGiayPhep: IdGiayPhep, cauhinh: cauhinh })
      .then((res) => {
        this.Get_BCDK_CauHinhTS(IdGiayPhep)
      })
      .catch((err) => message.error(err.message))
  };

  handleGP = (value) => {
    this.GetCT_GiayPhep_ByIdDVXCP(value)
  }
  handleUpdateCLXT = (item) => {
    debugger
    const { CLNDD, CLNM, idGiayPhep, danhgia } = this.state
    for (let index = 0; index < item.length; index++) {
      if (item[index].ketqua_danhgia === 1) {
        this.setState({ danhgia: 1 })
        break
      } else if (item[index].ketqua_danhgia === 0 || item[index].ketqua_danhgia === null || item[index].ketqua_danhgia === undefined) {
        this.setState({ danhgia: 0 })
      }
    }
    this.setState({
      CLXT: item.map((e, idx) => ({ ...e, stt: idx + 1 }))
    })
    let cLNT_ThongSos = "[]"
    let clndD_ThongSos = "[]"
    let clnM_ThongSos = "[]"
    if (item.length > 0) {
      cLNT_ThongSos = item[item.length - 1].list_kqqt
    } if (CLNDD.length > 0) {
      clndD_ThongSos = CLNDD[CLNDD.length - 1].list_kqqt
    } if (CLNM.length > 0) {
      clnM_ThongSos = CLNM[CLNM.length - 1].list_kqqt
    }
    this.Post_BCDK_CauHinhTS(idGiayPhep, { idGiayPhep: idGiayPhep, cLNT_ThongSos, clndD_ThongSos, clnM_ThongSos })
  }
  handleUpdateCLNM = (item) => {
    const { CLNDD, CLXT, idGiayPhep, danhgia } = this.state
    for (let index = 0; index < item.length; index++) {
      if (item[index].ketqua_danhgia === 1) {
        this.setState({ danhgia: 1 })
        break
      } else if (item[index].ketqua_danhgia === 0 || item[index].ketqua_danhgia === null || item[index].ketqua_danhgia === undefined) {
        this.setState({ danhgia: 0 })
      }
    }
    this.setState({
      CLNM: item.map((e, idx) => ({ ...e, stt: idx + 1 }))
    })
    let clnT_ThongSos = "[]"
    let clndD_ThongSos = "[]"
    let clnM_ThongSos = "[]"
    if (CLXT.length > 0) {
      clnT_ThongSos = CLXT[CLXT.length - 1].list_kqqt
    } if (CLNDD.length > 0) {
      clndD_ThongSos = CLNDD[CLNDD.length - 1].list_kqqt
    } if (item.length > 0) {
      clnM_ThongSos = item[item.length - 1].list_kqqt
    }
    this.Post_BCDK_CauHinhTS(idGiayPhep, { idGiayPhep: idGiayPhep, clnT_ThongSos, clndD_ThongSos, clnM_ThongSos })

  }

  handleUpdateCLNDD = (item) => {
    const { CLXT, CLNM, idGiayPhep, danhgia } = this.state
    for (let index = 0; index < item.length; index++) {
      if (item[index].ketqua_danhgia === 1) {
        this.setState({ danhgia: 1 })
        break
      } else if (item[index].ketqua_danhgia === 0 || item[index].ketqua_danhgia === null || item[index].ketqua_danhgia === undefined) {
        this.setState({ danhgia: 0 })
      }
    }
    this.setState({
      CLNDD: item.map((e, idx) => ({ ...e, stt: idx + 1 }))
    })
    let clnT_ThongSos = "[]"
    let clndD_ThongSos = "[]"
    let clnM_ThongSos = "[]"
    if (CLXT.length > 0) {
      clnT_ThongSos = CLXT[CLXT.length - 1].list_kqqt
    } if (item.length > 0) {
      clndD_ThongSos = item[item.length - 1].list_kqqt
    } if (CLNM.length > 0) {
      clnM_ThongSos = CLNM[CLNM.length - 1].list_kqqt
    }
    this.Post_BCDK_CauHinhTS(idGiayPhep, { idGiayPhep: idGiayPhep, clnT_ThongSos, clndD_ThongSos, clnM_ThongSos })

  }

  render() {
    const {
      handleCloseModal,
      selectedRow,
      isEdit,
      handleAdd,
      user, mode
    } = this.props;
    const { initialValues, dataGiayPhep, years, fileList, CLXT, CLNM, CLNDD, loaiGP, idGiayPhep, dataCLXT, dataCLNM, dataCLNDD, danhgia } = this.state
    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={addOrEditSchema}
          onSubmit={(values, actions) => {
            if (isEdit) {
              new Api_tnn()
                .PutDoanhNghiep_BaoCao({
                  token: this.props.user.access_token,
                  objBaocao: {
                    ...values,
                    idToChuc_CaNhan: values.idDonViXinCapPhep,
                    tenToChuc_CaNhan: values.tenDonViXCP,
                    diaChi: values.diaChiDonViXCP,
                    fileDinhKems: fileList,
                    nhomCongTrinh: loaiGP,
                    ketQua_DanhGia: danhgia,
                    clnM_KQQT_LIST: JSON.stringify(CLNM),
                    clndD_KQQT_LIST: JSON.stringify(CLNDD),
                    clnT_KQQT_LIST: JSON.stringify(CLXT),
                  },
                  id: selectedRow.id
                })
                .then(res => {
                  message.success(MESSAGE.CSCORE_UPDATE_SUCCESS);
                  handleAdd();
                  actions.resetForm({});
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
            else {
              new Api_tnn()
                .PostDoanhNghiep_BaoCao({
                  token: this.props.user.access_token,
                  objBaocao: {
                    ...values,
                    idToChuc_CaNhan: values.idDonViXinCapPhep,
                    tenToChuc_CaNhan: values.tenDonViXCP,
                    diaChi: values.diaChiDonViXCP,
                    fileDinhKems: fileList,
                    nhomCongTrinh: loaiGP,
                    ketQua_DanhGia: danhgia,
                    clnM_KQQT_LIST: JSON.stringify(CLNM),
                    clndD_KQQT_LIST: JSON.stringify(CLNDD),
                    clnT_KQQT_LIST: JSON.stringify(CLXT),
                  },
                })
                .then(res => {
                  message.success(MESSAGE.CSCORE_ADD_SUCCESS);
                  handleAdd();
                  actions.resetForm({});
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
          }}
          render={({
            errors,
            handleSubmit,
            touched,
            dirty,
            values,
            setFieldValue
          }) => (
              <form onSubmit={handleSubmit} autoComplete="false">
                <ControllerForm>
                  <Tabs type="card">
                    <TabPane tab={typo.cscore_common_info} key="1" forceRender={true}>

                      <Row>
                        <Col span={12}>
                          <ControllerInput>
                            <DonViXCPGroup
                              values={values}
                              setFieldValue={setFieldValue}
                              mode={isEdit ? "edit" : "add"}
                              handleGP={this.handleGP}
                              view={mode}
                            />
                            <Select
                              placeholder={Helper.genSelectPL(typo.cscore_license_number)}
                              label={typo.cscore_license_number}
                              onChange={(value, name) => {
                                setFieldValue("soGiayPhep", name.props.children);
                                setFieldValue("idGiayPhep", value);
                                setFieldValue("ngayCapPhep", Helper.getFieldValueFromID(value, dataGiayPhep, "ngayKy"));
                                this.Get_BCDK_CauHinhTS(value)
                                this.setState({
                                  loaiGP: Helper.getFieldValueFromID(value, dataGiayPhep, "nhomCongTrinh"),
                                  idGiayPhep: value
                                })
                              }}
                              dataSource={dataGiayPhep}
                              width="100%"
                              name="soVanBan"
                              name_value="id"
                              defaultValue={values.soGiayPhep}
                              value={values.soGiayPhep}
                              disabled={isEdit ? true : false}
                            />
                            <DateField
                              format={dateFormat}
                              placeholder={Helper.genSelectPL(typo.cscore_ngay_cap_phep)}
                              label={typo.cscore_ngay_cap_phep}
                              onChange={value => { setFieldValue("ngayCapPhep", value && value.format()) }}
                              defaultValue={values.ngayCapPhep}
                              value={values.ngayCapPhep ? moment(values.ngayCapPhep) : null}
                              disabled={true}
                            />

                            <FastField name="maBaoCao" render={({ field }) => (
                              <Input placeholder={typo.cscore_maBaoCao} label={typo.cscore_maBaoCao} mandatory={false} {...field} />)} />
                            <FastField name="tenBaoCao" render={({ field }) => (
                              <Input placeholder={typo.cscore_ten_quy_hoach} label={typo.cscore_ten_quy_hoach} {...field} />)} />
                            {touched.tenBaoCao && <ValidatedText type="danger">{errors.tenBaoCao}</ValidatedText>}


                          </ControllerInput>
                        </Col>
                        <Col span={12}>
                          <ControllerInput>
                            <NumberField
                              label={typo.cscore_dot_bao_cao}
                              placeholder={typo.cscore_dot_bao_cao}
                              id="dotBaoCao"
                              min={0}
                              onChange={value => setFieldValue("dotBaoCao", value)}
                              value={values.dotBaoCao}
                            />
                            <Select
                              dataSource={years}
                              defaultValue={values.namBaoCao ? Number(values.namBaoCao) : undefined}
                              onChange={(value) => { setFieldValue("namBaoCao", value) }}
                              placeholder={typo.cscore_chonnam}
                              label={typo.cscore_namBaoCao}
                              width="100%"
                              name="year"
                              name_value="year"
                              key={values.namBaoCao}
                            />
                            <FastField
                              name="noiDungBaoCao"
                              render={({ field }) => <TextArea placeholder={typo.cscore_noiDungBaoCao} label={typo.cscore_noiDungBaoCao} mandatory={false} {...field} rows={2} />}
                            />
                            <FastField
                              name="ghiChu"
                              render={({ field }) => <TextArea placeholder={typo.cscore_note} label={typo.cscore_note} mandatory={false} {...field} rows={2} />}
                            />
                          </ControllerInput>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <ControllerFile>
                            <Box label={typo.cscore_fileDinhkem}>
                              <FileDinhKemPlus dataSource={fileList} updateDataSource={this.updateFileDinhKems} />
                            </Box>
                          </ControllerFile>
                        </Col>
                      </Row>
                    </TabPane>
                    {loaiGP === Constant.DICT_NHOM_CT.XT &&
                      <TabPane tab={typo.cscore_chatLuongNuocThai} key="2">
                        <Box size="small">
                          <ChatLuongNuocThai mode={mode} dataSource={CLXT} handleUpdate={this.handleUpdateCLXT} doiTuongQT={Constant.DOI_TUONG_QUAN_TRAC[2].id} dataChatLuong={dataCLXT} idGiayPhep={idGiayPhep} key={CLXT} />
                        </Box>
                      </TabPane>
                    }
                    {loaiGP === Constant.DICT_NHOM_CT.XT &&
                      <TabPane tab={typo.cscore_chatLuongNuocMat} key="3">
                        <Box size="small">
                          <ChatLuongNuocMat mode={mode} dataSource={CLNM} handleUpdate={this.handleUpdateCLNM} doiTuongQT={Constant.DOI_TUONG_QUAN_TRAC[0].id} dataChatLuong={dataCLNM} idGiayPhep={idGiayPhep} key={CLNM} />
                        </Box>
                      </TabPane>
                    }
                    {loaiGP === Constant.DICT_NHOM_CT.NM &&
                      <TabPane tab={typo.cscore_chatLuongNuocMat} key="4">
                        <Box size="small">
                          <ChatLuongNuocMat mode={mode} dataSource={CLNM} handleUpdate={this.handleUpdateCLNM} doiTuongQT={Constant.DOI_TUONG_QUAN_TRAC[0].id} dataChatLuong={dataCLNM} idGiayPhep={idGiayPhep} key={CLNM} />
                        </Box>
                      </TabPane>
                    }
                    {loaiGP === Constant.DICT_NHOM_CT.NDD &&
                      <TabPane tab={typo.cscore_Chat_Luong_NDD} key="5">
                        <Box size="small">
                          <ChatLuongNuocMat mode={mode} dataSource={CLNDD} handleUpdate={this.handleUpdateCLNDD} doiTuongQT={Constant.DOI_TUONG_QUAN_TRAC[1].id} dataChatLuong={dataCLNDD} idGiayPhep={idGiayPhep} key={CLNDD} />
                        </Box>
                      </TabPane>
                    }
                  </Tabs>
                  <ControllerButton>
                    {mode !== 'view' &&
                      <button
                        className='ant-btn'
                        type="submit"
                      >
                        <Icon type="save" style={{ marginRight: "8px" }} />
                        {typo.cscore_submit}
                      </button>}
                    <Button
                      type="cancel"
                      className={styles.buttonMargin}
                      onClick={handleCloseModal}
                    >
                      <Icon type="arrow-right" />
                      {typo.cscore_exit}
                    </Button>
                  </ControllerButton>
                </ControllerForm>
              </form>
            )}
        />
      </div>
    );
  }
}

DNBCModal.propTypes = {
  handleAddAccount: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool
};

export default DNBCModal;
